/**
 * Read a recorded `blob:` url into a Blob via XMLHttpRequest. Web-only: the
 * recorder yields a `blob:` url (URL.createObjectURL); XHR is the browser
 * primitive and never routes through expo-file-system.
 */
export const uriToBlob = (uri: string): Promise<Blob> =>
	new Promise((resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.open("GET", uri, true);
		xhr.responseType = "blob";
		xhr.onload = () => {
			if (xhr.status === 0 || (xhr.status >= 200 && xhr.status < 300)) {
				resolve(xhr.response as Blob);
				return;
			}
			reject(new Error(`Failed to read recording (status ${xhr.status})`));
		};
		xhr.onerror = () => reject(new Error("Failed to read recording"));
		xhr.send();
	});

/** A playable data uri for a base64 mp3 (Daria's reply). */
export const base64ToMp3DataUri = (base64: string): string =>
	`data:audio/mp3;base64,${base64}`;
